/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018, 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

class APIStore {
	constructor() {
		this.apis = {};
	}
	set(key, api) {
		this.apis[key] = api;
	}
	remove(key) {
		delete this.apis[key];
	}
}

export default new Promise((resolve) => {
	const apiStore = new APIStore();
	window.exploreApis = {
		get: (key) => { return apiStore.apis[key]; }
	};
	resolve(apiStore);
});


// WEBPACK FOOTER //
// ./src/js/core/APIStore.js